import { useActions } from '@root/core/hooks/useActions';
import useDebounce from '@root/core/hooks/useDebounce';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import SearchTable from '@root/modules/Warehouse/Shared/Table/searchTable';
import { Button, Divider, Menu, MenuProps } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import { TableRowSelection } from 'antd/lib/table/interface';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import settlementService from '../../Services/settlementService';

interface labelSelect {
  key: string;
  label: string;
}
interface DataType {
  key: React.Key;
  ReceiptID: string;
  issuingDate: string;
  Customer: string;
  Amount: string;
  Fee: string;
  Status: string;
}
function ServiceInqueryTable() {
  // state
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [filterDateFrom, setFilterDateFrom] = useState<string>();
  const [filterDateTo, setFilterDateTo] = useState<string>();
  const [sort, setSort] = useState(true);
  const [valueSearch, setValueSearch] = useState<string>('');
  const debounce = useDebounce(valueSearch, 1000);
  const [filterBy, setFilterBy] = useState<string>();
  const [labelSearchType, setLabelSearchType] = useState<labelSelect>({
    key: '1',
    label: 'Select'
  });
  const [searchBy, setSearchBy] = useState<string>('');
  const [labelSearchFilter, setLabelSearchFilter] = useState<labelSelect>({
    key: '1',
    label: 'Select'
  });

  const getSelectFilterBy: MenuProps['onClick'] = (e) => {
    setLabelSearchType({ key: e.key, label: e.domEvent.target.innerText });
    setFilterBy(e.key);
    setCurrentPage(1);
  };

  const getSelectFilter: MenuProps['onClick'] = (e) => {
    setLabelSearchFilter({ key: e.key, label: e.domEvent.target.innerText });
    setSearchBy(e.key);
  };

  const getDate = (startDate: string, endDate: string) => {
    setFilterDateFrom(startDate);
    setFilterDateTo(endDate);
    setCurrentPage(1);
  };

  const getText = (text: string) => {
    setValueSearch(text);
  };
  const history = useHistory();

  const searchTypeSelect = [
    {
      id: 1,
      title: 'Select',
      list: (
        <Menu
          onClick={getSelectFilterBy}
          items={[
            { label: 'Request', key: 'Request' },
            {
              label: 'Completed',
              key: 'Completed'
            }
          ]}
        />
      )
    }
  ];

  const searchFilterSelect = [
    {
      id: 1,
      title: 'Select',
      list: (
        <Menu
          onClick={getSelectFilter}
          items={[
            { label: 'Receipt ID', key: 'receiptId' },
            {
              label: 'Customer',
              key: 'email'
            }
          ]}
        />
      )
    }
  ];

  // table service
  const columns: ColumnsType<DataType> = [
    {
      title: 'Receipt ID',
      dataIndex: 'receiptId'
    },
    {
      title: 'Issuing Date',
      dataIndex: 'IssuingDate'
    },
    {
      title: 'Customer ID ',
      dataIndex: 'email'
    },
    {
      title: 'Amount',
      dataIndex: 'billingAmount'
    },
    {
      title: 'Fee',
      dataIndex: 'serviceAmount'
    },
    {
      title: 'Status',
      dataIndex: 'serviceStatus'
    }
  ];

  // getting list settlement
  const { handleGetServiceList } = useActions();

  useEffect(() => {
    handleGetServiceList(
      currentPage,
      sort,
      filterDateFrom,
      filterDateTo,
      filterBy,
      searchBy,
      debounce
    );
  }, [sort, filterDateFrom, filterDateTo, filterBy, searchBy, debounce]);

  const { data } = useTypedSelector((state) => state.settlementReducer);

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection: TableRowSelection<DataType> = {
    selectedRowKeys,
    onChange: onSelectChange,
    preserveSelectedRowKeys: true
  };

  // download billing inquiry
  const idMap = selectedRowKeys.map((item: React.Key) => item);

  const arrId = {
    ids: idMap
  };
  const serviceInquiry = true;

  const handleDownload = async () => {
    if (selectedRowKeys.length === 0) {
      const resp = await settlementService.postDownloadExcel(
        currentPage,
        sort,
        filterDateFrom,
        filterDateTo,
        filterBy,
        searchBy,
        valueSearch,
        serviceInquiry
      );
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Service_inquiry_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([resp]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await settlementService.postDownloadExelId(
        arrId,
        serviceInquiry
      );
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Service_inquiry_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  return (
    <div className="tableBilling">
      <SearchTable
        labelSearchType={labelSearchType}
        labelSearchFilter={labelSearchFilter}
        isBilling={true}
        getDate={getDate}
        searchText={getText}
        searchType={searchTypeSelect}
        searchFilter={searchFilterSelect}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '15px 17px',
          background: 'white',
          alignItems: 'center'
        }}
      >
        <div>
          <span style={{ marginLeft: 8, marginRight: 8 }}>
            Total Inquiry {data?.count}
          </span>
          <Divider type="vertical" />
          <span style={{ marginLeft: 8 }}>
            Selected Inquiry {selectedRowKeys.length}
          </span>
        </div>

        <div>
          <Button className="downExcel" onClick={handleDownload}>
            Download Excel
          </Button>
        </div>
      </div>
      <Table
        className="warehouse-table"
        rowSelection={rowSelection}
        columns={columns}
        dataSource={data?.rowData}
        pagination={{
          pageSize: 10,
          total: data.count,
          current: currentPage,
          onChange: (currentPage) => {
            setCurrentPage(currentPage);
            handleGetServiceList(
              currentPage,
              sort,
              filterDateFrom,
              filterDateTo,
              filterBy,
              searchBy,
              valueSearch
            );
          }
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              history.push({
                pathname: `/admin/serviceInquiry/serviceInquiryDetail/${record.key}`
              });
            }
          };
        }}
      />
    </div>
  );
}

export default ServiceInqueryTable;
